// The organization at the top of the screens before and around the session
// (INC-12a, A.4): the access screen of the three experiences and the screens
// of invitation, password and state that repeat its form.
//
// One fallback order, the same the field's bar and the office's menu follow:
// the logo; without one, the square mark with the name; without either, the
// name alone. The name, when it goes, is in ink and never in a brand colour
// over the neutral ground (D-174); the logo carries the name as its
// alternative text. An image that does not arrive falls to the next step,
// never to a broken picture.
import { useState } from 'react';

export function BrandLockup({
  name,
  logoUrl,
  markUrl,
}: {
  name: string;
  logoUrl?: string | null;
  markUrl?: string | null;
}) {
  // The sources that failed, each tried once: a different image is tried next.
  const [failed, setFailed] = useState<readonly string[]>([]);
  const usable = (url: string | null | undefined): url is string =>
    url != null && url !== '' && !failed.includes(url);
  const logo = usable(logoUrl) ? logoUrl : null;
  const mark = logo === null && usable(markUrl) ? markUrl : null;
  const fail = (url: string) => (): void => {
    setFailed((current) => (current.includes(url) ? current : [...current, url]));
  };
  return (
    <div className="ui-brand-lockup" data-testid="brand-lockup">
      {logo !== null ? (
        <img
          className="ui-brand-lockup-logo"
          src={logo}
          alt={name}
          data-testid="tenant-logo"
          onError={fail(logo)}
        />
      ) : (
        <>
          {mark !== null ? (
            <img
              className="ui-brand-lockup-mark"
              src={mark}
              alt=""
              data-testid="tenant-mark"
              onError={fail(mark)}
            />
          ) : null}
          <h1 className="ui-brand-lockup-name" data-testid="tenant-name">
            {name}
          </h1>
        </>
      )}
    </div>
  );
}
